import axios from 'axios';
import { Toast } from "@51job/vant";
import store from '@/store';
import base from "@/utils/common";
import qs from 'qs';
import HmacSHA256 from "crypto-js/hmac-sha256";
import { cupid_sign_key } from "@/utils/constant";

Toast.allowMultiple();
//创建一个独立的axios实例
const service = axios.create({
  baseURL: 'https://cupid.51job.com',
  headers: {
    post: {
      'Content-Type': 'application/json'
    },
    get: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  },
  timeout: 30000,
  withCredentials: false
});
// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    if (error.response.status != 401) Toast(error.response.data.message);
  } else {
    Toast('网络请求异常，请稍后重试!');
  }
  return Promise.reject(error.response);
};
// 请求拦截
service.interceptors.request.use((config) => {
  var request_string = config.url + (config.data || '');
  if (config.method === 'upload') {
    config.method = 'post';
    config.headers['Content-Type'] = 'multipart/form-data';
    request_string = config.url;
  }
  config.headers.sign = HmacSHA256(
    request_string,
    cupid_sign_key
  );
  
  config.headers["uuid"] = base.getuuid();
  config.headers["From-Domain"] = store.getters.fromdomain;
  config.headers["account-id"] = localStorage.getItem("accountId") || "";
  config.headers["user-token"] = localStorage.getItem("token") || "";
  config.headers["X-Auth-Token"] = localStorage.getItem("X-Auth-Token");
  config.headers["partner"] = store.state.commonStore.partner;
  config.headers["property"] = encodeURIComponent(
    JSON.stringify({ ...base.getProperty(), ...(config.property || {}) })
  );

  return config;
});
// 返回拦截
service.interceptors.response.use((response) => {
  return response.data;
}, errorHandler);

/**核心函数，可通过它处理一切请求数据，并做横向扩展
 * noToastStatus业务特殊处理的状态码，不提示msg
 */
// eslint-disable-next-line no-unused-vars
const callFunc = (
  url,
  params = {},
  options = {
    loading: false,
    mock: false,
    error: true,
    noToastStatus: [],
    property: {}
  },
  method = 'post'
) => {
  var toast1;
  if (options.loading) {
    Toast.clear();
    toast1 = Toast.loading({
      message: 'Loading...',
      forbidClick: true,
      duration: 0
    });
  }
  url = url[0] === '/' ? url.substring(1, url.length) : url;
  var newdata = {
    url:
    '/' + url + '?api_key=51job&timestamp=' + parseInt(new Date().getTime() / 1000),
    method: method,
    property: options.property
  };
  if (method == 'get' && JSON.stringify(params) != '{}') {
    newdata.url = newdata.url + '&' + qs.stringify(params);
  } else if (method == 'post' && JSON.stringify(params) != '{}') {
    newdata.data = JSON.stringify(params);
    //post请求的额外get参数
    if (options.postfix) {
      newdata.url = newdata.url + '&' + qs.stringify(options.postfix);
    }
  } else if (method == 'upload') {
    newdata.data = params;
  }
  return new Promise((resolve) => {
    service(newdata)
      .then((res) => {
        resolve(res);
        if (
          [
            '600011',
            '600101',
            '110101',
            '110102',
            '110103',
            '110104',
            '110011'
          ].indexOf(res.status) > -1
        ) {
          // loginJs.logoOut();
          return;
        }
        //非这些情况提示msg,需要noToastStatus配合
        if (
          !(
            res.status == 1 ||
						(options.noToastStatus &&
							options.noToastStatus.indexOf(res.status) > -1)
          )
        ) {
          Toast(res.message);
        }
      })
      .catch((error) => {
        //登录失效的错误、令牌失效等，要重新登录
        if (error && error.status == 401) {
          // loginJs.logoOut();
        }
      })
      .finally(() => {
        if (toast1) {
          toast1.clear();
        }
      });
  });
};
//**************接口***********************
const post = (url, params = {}, options) => {
  return callFunc(url, params, options, 'post');
};
const get = (url, params = {}, options) => {
  return callFunc(url, params, options, 'get');
};
const getNew = (url, params = {}) => {
  return callFunc(
    url,
    params.params,
    { loading: params.loading, property: params.property },
    'get'
  );
};
const del = (url, params = {}, options) => {
  return callFunc(url, params, options, 'delete');
};
const upload = (url, params = {}, options) => {
  return callFunc(url, params, options, 'upload');
};
export default {
  post,
  get,
  del,
  upload,
  getNew
};
